<p-table dataKey="caseId" [value]="data" [columns]="cols" [rows]="rows" [scrollable]="false" [paginator]="true"
  [alwaysShowPaginator]="false" [(expandedRowKeys)]="expandedRows" selectionMode="single" [(selection)]="selectedRow">

  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
      @for (col of columns; track $index) {
      <col [style.width]="col.width" />
      }
    </colgroup>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track $index) {
      <th>{{ col.header }}</th>
      }
    </tr>
  </ng-template>

  <ng-template #body let-caseItem let-expanded="expanded" let-columns="columns">
    <tr [pSelectableRow]="caseItem">
      <td class="py-0!">
        <button 
          pButton 
          type="button" 
          text
          rounded 
          [pRowToggler]="caseItem" 
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <td class ="py-4! px-5!">{{ caseItem.caseId }}</td>
      <td class ="py-4! px-5!">{{ caseItem.updateReceivedDateTime | utcToLocal: 'MM/dd/yyyy hh:mm aa' }}</td>
      <td class ="py-4! px-5!">{{ caseItem.caseStatus }}</td>
      <td class ="py-4! px-5!">{{ caseItem.programReasonForManagement }}</td>
      <td class ="py-4! px-5!">{{ caseItem.caseOwnerTeam }}</td>
      <td class ="py-4! px-5!">{{ caseItem.rfmRiskLevel }}</td>
    </tr>
  </ng-template>

  <ng-template #expandedrow let-caseItem>
    <tr>
      <td class="p-0" [attr.colspan]="cols.length">
        <div class="py-4">
          <div class="expanded-grid">
            <div class="mt-4 ml-8">
              <div class="field flex items-baseline">
                <label class="inline-block w-56 shrink-0">Program Name:</label>
                <p class="p-field-value whitespace-nowrap">{{ caseItem.details.programName | emptyPlaceholder }}</p>
              </div>

              <div class="field flex items-baseline">
                <label class="inline-block w-56 shrink-0">Program Status:</label>
                <p class="p-field-value whitespace-nowrap">{{ caseItem.details.programStatus | emptyPlaceholder }}</p>
              </div>

              <div class="field flex items-baseline">
                <label class="inline-block w-56 shrink-0">Program Status Reason:</label>
                <p class="p-field-value whitespace-nowrap">{{ caseItem.details.programStatusReason | emptyPlaceholder }}</p>
              </div>

              <div class="field flex items-baseline">
                <label class="inline-block w-56 shrink-0">Case Created Date:</label>
                <p class="p-field-value whitespace-nowrap">{{ caseItem.details.caseCreatedDate ? (caseItem.details.caseCreatedDate | utcToLocal: 'MM/dd/yyyy hh:mm:ss aa') : '' | emptyPlaceholder }}</p>
              </div>

              <div class="field flex items-baseline">
                <label class="inline-block w-56 shrink-0">Predictive Risk Score:</label>
                <p class="p-field-value whitespace-nowrap">{{ caseItem.details.predictiveRiskScore | emptyPlaceholder }}</p>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td class="w-full" [attr.colspan]="cols.length">
        No records found
      </td>
    </tr>
  </ng-template>
</p-table>